import CardDetails from '../store/schema/CardDetails';
import ExecuteActionResponse from '../store/schema/ExecuteActionResponse';
import MessageContext from '../store/schema/MessageContext';
import TelemetryProvider from '../store/schema/TelemetryProvider';
import TelemetryDetails from '../store/schema/TelemetryDetails';
import ElementDetails from '../store/schema/ElementDetails';
import { Action, Input } from 'adaptivecards';
import CustomToggleVisibilityAction from '../cardActions/CustomToggleVisibilityAction';
import CustomOpenUrlAction from '../cardActions/CustomOpenUrlAction';
import { MESSAGE_CARD_VIEW_ACTION_CLICKED, ACTION_CONTEXT } from '../constants';

import { trace } from 'owa-trace';

export default function executeAction(
    action: Action,
    cardDetails: CardDetails,
    inputs: Input[],
    handleActionResponse: (response: ExecuteActionResponse) => void,
    messageContext: MessageContext,
    telemetryProvider: TelemetryProvider
): boolean {
    trace.info('[ActionableMessageDebug] executeAction: cardActionExecuted');

    const elementDetails: ElementDetails = {
        id: action.id,
        type: action.getJsonTypeName(),
    };

    const telemetryDetails: TelemetryDetails = {
        messageContext: messageContext,
        actionContext: action[ACTION_CONTEXT],
        cardDetails: cardDetails,
        elementDetails: elementDetails,
        eventName: undefined,
    };

    if (action instanceof CustomOpenUrlAction) {
        trace.info('[ActionableMessageDebug] onExecuteAction: open url: ' + action.url);
        telemetryDetails.eventName = MESSAGE_CARD_VIEW_ACTION_CLICKED;
        telemetryProvider.logTelemetry(telemetryDetails);

        try {
            const url = new URL(action.url);
            if (url.protocol.toLowerCase() === 'http:' || url.protocol.toLowerCase() === 'https:') {
                window.open(url.href, '_blank');
            } else {
                const traceInfoMessage: string =
                    url.protocol.toLowerCase() === 'mailto:' ? 'Mailto action' : 'Invalid URL';
                trace.info(
                    '[ActionableMessageDebug] onExecuteAction: open url not executed.' +
                        traceInfoMessage
                );
                return false;
            }
        } catch {
            trace.info(
                '[ActionableMessageDebug] onExecuteAction: open url not executed. Malformed URL'
            );
        }
        return true;
    } else if (action instanceof CustomToggleVisibilityAction) {
        trace.info('[ActionableMessageDebug] onExecuteAction: Toggle Visibility');
        action.execute();
        return true;
    }

    return false;
}
